(function ($) {

	function updateEdgeClasses(swiper, el) {
		const $container = el.find('.swiper-container');

		if (swiper.isLocked) {
			$container.addClass('-at-start -at-end');
			return;
		}

		if (swiper.isBeginning) {
			$container.addClass('-at-start').removeClass('-at-end');
		} else if (swiper.isEnd) {
			$container.addClass('-at-end').removeClass('-at-start');
		} else {
			$container.removeClass('-at-start -at-end');
		}
	}

	function productCrossSellSlider() {
		$(".product-detail-cross-sell__slider").each(function () {
			var $this = $(this);
			var Products = new Swiper($this.find('.swiper-container')[0], {
				slidesPerView: 2,
				loop: false,
				spaceBetween: 8,
				freeMode: true,
				watchOverflow: true,
				mousewheel: {
					forceToAxis: true,
				},
				navigation: {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev',
				},
				on: {
					init: function () {
						updateEdgeClasses(this, $this);
					},
					resize: function () {
						updateEdgeClasses(this, $this);
					},
					setTranslate: function () {
						updateEdgeClasses(this, $this);
					},
				},
				breakpoints:{
					767: {
						freeMode: false,
						slidesPerView: 3,
					},
					900: {
						slidesPerView: 2,
					},
					1200: {
						slidesPerView: 3,
						spaceBetween: 12,
					},
					1400: {
						slidesPerView: 4,
					},
				}
			});
		});
	}
	productCrossSellSlider();
	$(document).gp_ready(function (){
		productCrossSellSlider();
	})

})(jQuery);
